<template>
  <div class="column col-6">
    <div class="row jt-search-container-ownership-change">
      <div
        class="column col-10"
      >
        <jt-input
          ref="input"
          v-model="searchField"
          name="jtsearch-input"
          type="text"
          mask=""
          :label="label"
          :error="error"
          :disable="false"
          :inverted="false"
          :dark="dark"
          :focused="false"
          :required="true"
          :filled="false"
          :outlined="true"
          :standout="false"
          :borderless="false"
          :rounded="false"
          :square="false"
          hide-bottom-space

          @clear="onClearHandler"
          @focus="__onFocus"
          @blur="onBlurHandler"
          @keydown="__onKeydown"
          @keyup.enter="
            () => {
              fetchData();
            }
          "
        />
      </div>
      <div
        :class="'col-2'"
        style="display: flex"
      >
        <q-btn
          color="grey-3"
          :inverted="inverted"
          :disable="disable"
          class="btn"
          @click="openModal"
        >
          <q-icon size="2em" color="primary" name="swap_horiz" />
        </q-btn>
      </div>
      <jt-search-ownership-change-modal
        v-if="renderModal"
        :ownershipChangeForm="ownershipChangeForm"
        :ownershipChangeFilesForm="ownershipChangeFilesForm"
        :ownershipChangeDatesForm="ownershipChangeDatesForm"
        @on-close="closeModal"
        @on-save="onSaveOwnershipChange"

      />
    </div>
  </div>
</template>
<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { InputMixin } from 'jtech-webcomps/src/mixins'
import { JtInput, JtDynamicForm } from 'jtech-webcomps'
import { repository, messageBox } from 'jtech'
import { QBtn, QInput, QFooter, QPageContainer } from 'quasar'
import JtSearchOwnershipChangeModal from './JtSearchOwnershipChangeModal.vue'

  @Component({
    name: 'JtSearchOwnershipChange',
    mixins: [InputMixin],
    components: { JtInput, JtDynamicForm, JtSearchOwnershipChangeModal, QBtn, QInput, QFooter, QPageContainer },
    props: {
      consumerUnitData: {
        type: Object
      },
      consumerUnitField: {
        type: Number
      },
      label: {
        type: String
      },
      type: {
        type: String,
        default: 'text'
      },
      mask: {
        type: String,
        default: ''
      },
      multiselect: {
        type: Boolean,
        default: false
      },
      extraParams: {
        type: Object
      }
    }
  })
class JtSearchOwnershipChange extends Vue {
    renderModal = false;
    ownershipChangeForm = null;
    ownershipChangeFilesForm = {};
    ownershipChangeDatesForm = {};
    nmInterfaceOwnerOccupier = 'ownershipChange.ownerAndOccupier';
    nmInterfaceFiles = 'ownershipChange.files';
    nmInterfaceDates = 'ownershipChange.dates';
    searchField = null;
    searchFieldMemory = null;

    created () {
      if (this.value) this.fetchData('id')
    }

    async mounted () {
      await this.initComponent()
    }

    async initComponent () {
      const formOwnerOccupier = await repository.resolve(this.nmInterfaceOwnerOccupier)
      const formFiles = await repository.resolve(this.nmInterfaceFiles)
      const formDates = await repository.resolve(this.nmInterfaceDates)
      const registros = await this.getPerson(this.consumerUnitField)
      this.searchField = registros[0].name
      this.searchFieldMemory = registros[0].name
      this.ownershipChangeForm = formOwnerOccupier[0]
      this.ownershipChangeForm.dadosForm = {
        newOwner: this.consumerUnitData.newOwner,
        newOccupier: this.consumerUnitData.newOccupier,
        oldOwner: this.consumerUnitData.oldOwner,
        oldOccupier: this.consumerUnitData.oldOccupier,
        consumerUnitClients: this.consumerUnitData.consumerUnitClients
      }
      this.ownershipChangeFilesForm = formFiles[0]
      this.ownershipChangeDatesForm = formDates[0]
    }

    onSaveOwnershipChange (data) {
      this.$emit('on-save-ownership', data)
      this.renderModal = false
    }

    closeModal () {
      this.ownershipChangeForm = null
      this.renderModal = false
    }

    async getPerson (idField) {
      const param = { id: idField }
      const { registros } = await repository.resolveDatatableModel(
        'person.pesquisarSelecaoOwnershipChange',
        param
      )
      return registros
    }

    async openModal () {
      if (!this.ownershipChangeForm) {
        await this.initComponent()
      }
      this.renderModal = true
    }

    async onBlurHandler (e) {
      this.__onBlur(e)
      if (!this.searchField) {
        await this.fetchData()
      } else if (this.searchField !== this.searchFieldMemory) {
        if (this.searchFieldMemory) this.searchField = this.searchFieldMemory
        else this.onClearHandler()
      }
    }

    @Watch('consumerUnitField')
    async onConsumerUnitFieldChange (value, _) {
      const person = await this.getPerson(value)
      this.searchField = person[0].name
      this.searchFieldMemory = person[0].name
    }
  }
export default JtSearchOwnershipChange
</script>
  <style lang="stylus" scoped>
  .jt-search-container-ownership-change {
    overflow: hidden;
  }

  .jt-search-container-ownership-change .btn {
    height: 50px !important;
    width: 50px !important;
    margin: 1px 5px !important;
    border-radius: 8px !important;
  }

  </style>
